import { ThemeEvents } from '@theme/events';

const FITS = ['regular', 'oversized'];
const MOBILE_MEDIA_QUERY = '(max-width: 749px)';
const PENDING_FIT_ATTRIBUTE = 'data-soulcore-pending-fit';

function normalizeFit(value = '') {
  const normalized = String(value).trim().toLowerCase();
  return FITS.find((fit) => normalized.includes(fit)) || '';
}

function fitFromControl(control) {
  if (control instanceof HTMLSelectElement) {
    const optionName = control.name.match(/^options\[(.+)\]$/)?.[1]?.trim().toLowerCase();
    if (optionName !== 'corte') return '';
    return normalizeFit(control.value);
  }

  if (control instanceof HTMLInputElement && control.type === 'radio') {
    const fieldset = control.closest('fieldset');
    const legend = fieldset?.querySelector(':scope > legend')?.textContent?.trim().toLowerCase() || '';
    if (!legend.startsWith('corte')) return '';
    return normalizeFit(control.value);
  }

  return '';
}

function decorateGallery(gallery) {
  if (!(gallery instanceof HTMLElement)) return;

  const mediaItems = gallery.querySelectorAll('.product-media');

  for (const media of mediaItems) {
    if (!(media instanceof HTMLElement)) continue;
    if (media.closest('.dialog-zoomed-gallery')) continue;

    const image = media.querySelector('.product-media__image');
    if (!(image instanceof HTMLImageElement)) continue;

    const fit = normalizeFit(image.alt);
    if (!fit) {
      media.removeAttribute('data-sc-fit');
      media.querySelector(':scope > .soulcore-fit-badge')?.remove();
      continue;
    }

    media.dataset.scFit = fit;

    if (!media.querySelector(':scope > .soulcore-fit-badge')) {
      const badge = document.createElement('span');
      badge.className = 'soulcore-fit-badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = `CORTE ${fit.toUpperCase()}`;
      media.appendChild(badge);
    }
  }
}

function focusFit(gallery, fit, attempt = 0) {
  if (!(gallery instanceof HTMLElement)) return;

  decorateGallery(gallery);

  const shouldUseCarousel =
    window.matchMedia(MOBILE_MEDIA_QUERY).matches || gallery.dataset.presentation === 'carousel';

  if (shouldUseCarousel) {
    const slideshow = gallery.querySelector('slideshow-component[ref="slideshow"]');
    const targetMedia = slideshow?.querySelector(`.product-media[data-sc-fit="${fit}"]`);
    const targetSlide = targetMedia?.closest('slideshow-slide');

    if (
      slideshow &&
      targetSlide &&
      typeof slideshow.select === 'function'
    ) {
      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      const index = slides.indexOf(targetSlide);
      if (index >= 0) {
        slideshow.select(index, undefined, { animate: true });
        return;
      }
    }

    if (attempt < 10) {
      window.setTimeout(() => focusFit(gallery, fit, attempt + 1), 50);
    }
    return;
  }

  const targetMedia = gallery.querySelector(`.media-gallery__grid .product-media[data-sc-fit="${fit}"]`);
  const target = targetMedia?.closest('li') || targetMedia;

  if (target instanceof HTMLElement) {
    target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  }
}

function decorateAll(root = document) {
  root.querySelectorAll('media-gallery').forEach(decorateGallery);
}

if (!window.__soulcoreFitGalleryInitialized) {
  window.__soulcoreFitGalleryInitialized = true;

  decorateAll();

  document.addEventListener('change', (event) => {
    const control = event.target;
    if (!(control instanceof HTMLSelectElement || control instanceof HTMLInputElement)) return;

    const fit = fitFromControl(control);
    if (!fit) return;

    const scope = control.closest('.shopify-section, dialog');
    if (!(scope instanceof HTMLElement)) return;

    scope.setAttribute(PENDING_FIT_ATTRIBUTE, fit);
  });

  document.addEventListener(ThemeEvents.variantUpdate, (event) => {
    const origin = event.target;
    if (!(origin instanceof Element)) return;

    const scope = origin.closest('.shopify-section, dialog');
    if (!(scope instanceof HTMLElement)) return;

    const fit = scope.getAttribute(PENDING_FIT_ATTRIBUTE) || '';
    scope.removeAttribute(PENDING_FIT_ATTRIBUTE);

    requestAnimationFrame(() => {
      decorateAll(scope);
      if (!fit) return;

      const gallery = scope.querySelector('media-gallery');
      if (gallery instanceof HTMLElement) {
        focusFit(gallery, fit);
      }
    });
  });
}
